import React from 'react'
import './Wwo.css'
import CountUpOnScroll from '../../Home/About/ScrollCounter'
import cs from '../../../../assets/img/globe.svg'
import pd from '../../../../assets/img/project_delivered.svg'
import te from '../../../../assets/img/te.svg'
import yoe from '../../../../assets/img/yoe.svg'
import cwad from '../../../../assets/img/cwad.svg'
import ecde from '../../../../assets/img/ecde.svg'
import swad from '../../../../assets/img/swad.svg'
import pwa from '../../../../assets/img/pwa.svg'
import wasm from '../../../../assets/img/wasm.svg'

function Wwo() {

  const wwolist = [
    {
      icon:cwad,
      title: "MVP and Market Validation",
      desc: "We validate product-market fit quickly by building focused MVPs and running early user tests to capture feedback and iterate fast."
    },
    {
      icon:ecde,
      title: "Architecture for Scale",
      desc: "We design multi-tenant architectures, tenancy isolation strategies, and autoscaling patterns so your product can grow without major refactors."
    },
    {
      icon:swad,
      title: "Security, Compliance and Data Privacy",
      desc: "Security and data governance are embedded from day one. We help assess compliance needs and implement encryption, backups, and audit trails."
    },
    {
      icon:pwa,
      title: "Operational Excellence",
      desc: "CI/CD pipelines, observability, logging and on-call playbooks ensure reliability and predictable updates with minimal downtime."
    },
    {
      icon:wasm,
      title: "Customer Success and Product Iteration",
      desc: "We support product teams with feature roadmaps, telemetry-driven product decisions, and continuous UX improvements based on customer feedback."
    },
    
  ]

  return (
    <section className='wwo-sec'>
        <div className='container'>
            <div className='pht-sec'>
                <ul>
                    <li><img src={cs} alt='Countries Served' width={64} height={64} loading="lazy"/><h4> <CountUpOnScroll end={25} />+</h4><p>Countries Served</p></li>
                    <li><img src={pd} alt='Projects Delivered' width={64} height={64} loading="lazy"/><h4> <CountUpOnScroll end={200} />+</h4><p>Projects Delivered</p></li>
                    <li><img src={te} alt='Tech Enthusiast' width={64} height={64} loading="lazy"/><h4> <CountUpOnScroll end={120} />+</h4><p>Tech Enthusiast</p></li>
                    <li><img src={yoe} alt='Years of Experience' width={64} height={64} loading="lazy"/><h4> <CountUpOnScroll end={10} />+</h4><p>Years of Experience</p></li>
                </ul>
            </div>
            <div className='wwo-sec1'>
            <h3>Our SaaS Development Path            </h3>
              <ul>
                {
                  wwolist.map((Wwo, index)=>(
                    <li key={index}>
                      <div className='wwo-icon'><img src={Wwo.icon} alt={Wwo.title} width={64} height={64}/></div>
                      <h4>{Wwo.title}</h4> 
                      <p>{Wwo.desc}</p>  
                    </li>
                  ))
                }
                   
              </ul>    
            </div> 
        </div>
    </section>
  )
}

export default Wwo
